module["exports"] = [
  "#{prefix} #{first_name} #{last_name}",
  "#{first_name} #{last_name}",
  "#{first_name} #{last_name}",
  "#{first_name} #{last_name}",
  "#{first_name} #{last_name}",
  "#{first_name} #{last_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/tr/name/name.js
// module id = 1915
// module chunks = 0